var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPescatarianIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.169,
    height: 81.835,
    viewBox: "0 0 91.169 81.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1Pesca{fill:none;stroke:#e5b515;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}.cls-2Pesca{fill:#e5b515}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pescatarian",
    transform: "translate(-1401.461 -2074.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(1436.511 2095.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    d: "M1589.432 2248.869c16.416 5.483 27.454 20.392 12.789 36.1-15.026-8.2-18.322-25.075-18.322-25.075",
    className: "cls-1Pesca",
    transform: "translate(-1577.069 -2229.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    d: "M1595.468 2416.37a29.32 29.32 0 0 1-11.468-2.27",
    className: "cls-1Pesca",
    transform: "translate(-1577.146 -2357.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    d: "M1654.713 2212.488c15.6-1.58 26.678-20.068 10.951-46.931-7.892 1.276-21.482 4.764-27.664 17.292",
    className: "cls-1Pesca",
    transform: "translate(-1618.751 -2165.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    d: "M1698.077 2227.7c7.935-5.888 10.136-20.491 10.136-20.491",
    className: "cls-1Pesca",
    transform: "translate(-1665.036 -2197.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    d: "M1637.4 2342.448s-1.366-6.83 4.1-13.661",
    className: "cls-1Pesca",
    transform: "translate(-1618.171 -2291.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    d: "M1608.058 2309.7s-1.621-5.95 3.844-12.78",
    className: "cls-1Pesca",
    transform: "translate(-1595.509 -2266.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    d: "M1596.3 2380.947s-4.2-3.218-12.4-1.852",
    className: "cls-1Pesca",
    transform: "translate(-1577.069 -2329.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    d: "M1566.694 2340.938s-5.719-4.584-12.549-3.218",
    className: "cls-1Pesca",
    transform: "translate(-1554.145 -2298.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    d: "M1709.579 2296.695c-4.1-2.732-11.5-1.366-11.5-1.366",
    className: "cls-1Pesca",
    transform: "translate(-1665.036 -2265.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    d: "M1724.833 2259.569a12.136 12.136 0 0 1 8.092-.486",
    className: "cls-1Pesca",
    transform: "translate(-1685.65 -2237.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    d: "M1706.834 2230.135a10.538 10.538 0 0 0-5.363-8.9",
    className: "cls-1Pesca",
    transform: "translate(-1667.651 -2208.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    d: "M1677.227 2247.9c5.437 2.931 5.36 11.15 5.36 11.15",
    className: "cls-1Pesca",
    transform: "translate(-1648.973 -2229.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(1401.461 2074.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nCWwRb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    d: "M1426.6 2074.044c2.839.9 4.89 2.907 6.844 5a36.713 36.713 0 0 1 9.244 18.294 40.5 40.5 0 0 1 .546 9.3c-.039 1.132-.182 2.26-.247 3.391a1.15 1.15 0 0 0 .2.638 75.489 75.489 0 0 1 6.191 11.71 7.712 7.712 0 0 1 .265.741c.335 1.1-.348 1.938-1.465 1.7-1.509-.327-3-.733-4.485-1.169-.991-.292-1.95-.695-2.924-1.047-.193-.07-.388-.135-.629-.218-.186.462-.374.9-.544 1.352a63.5 63.5 0 0 1-6.661 12.852c-.648.968-.656.657.112 1.535a34.01 34.01 0 0 1 4.792 7.634 60.4 60.4 0 0 1 3 7.316c.057.17.1.345.146.519.253.982.054 1.407-.85 1.823h-.249a38.628 38.628 0 0 1-13.572-7.88c-.1.083-.161.135-.22.192a29.239 29.239 0 0 1-7.587 5.218c-1.876.921-3.845 1.654-5.772 2.471h-.5a5.4 5.4 0 0 1-.494-.36 1.084 1.084 0 0 1-.361-1.266c.834-2.177 1.614-4.378 2.521-6.525a36.135 36.135 0 0 1 4.336-7.669c.614-.818 1.271-1.6 1.925-2.424-.259-.372-.539-.744-.789-1.137a70.515 70.515 0 0 1-7.714-16.284c-.335-1.042-.355-1.063-1.4-.693a53.857 53.857 0 0 1-6.743 2.015 4.894 4.894 0 0 0-.529.1 1.242 1.242 0 0 1-1.437-1.667c1.029-2.215 1.959-4.477 3.019-6.677a45.907 45.907 0 0 1 4.2-6.847 2.275 2.275 0 0 0 .279-1.139c.112-1.752.1-3.516.3-5.258a35.661 35.661 0 0 1 4.509-13.939 30.481 30.481 0 0 1 8.51-9.736 12.28 12.28 0 0 1 3.4-1.862zm13.071 21.4c-.17.07-.236.091-.3.123-.146.078-.292.157-.434.243a24.33 24.33 0 0 1-22.6 1.48c-1.1-.519-2.149-1.134-3.211-1.724-.3-.168-.46-.109-.538.21-.1.389-.2.776-.271 1.169a50.826 50.826 0 0 0-.707 8.341 3.572 3.572 0 0 1-.785 2.255 54.492 54.492 0 0 0-5.79 10.129 3.789 3.789 0 0 0-.124.4 5.2 5.2 0 0 0 .687-.139c1.675-.6 3.346-1.217 5.019-1.824.466-.169.929-.355 1.408-.479a.839.839 0 0 1 1.1.5 8.645 8.645 0 0 1 .523 1.348 66.93 66.93 0 0 0 3.284 8.846 67.8 67.8 0 0 0 5.68 9.963c.737 1.079.718 1.211-.1 2.2-.8.956-1.646 1.872-2.386 2.869a43.206 43.206 0 0 0-5.2 10.054 3.066 3.066 0 0 0-.091.405c.258-.09.456-.142.64-.225a27.08 27.08 0 0 0 9.141-6.109 8.964 8.964 0 0 1 1.091-.953.89.89 0 0 1 1.184.006c.39.308.77.631 1.127.977a33.414 33.414 0 0 0 9.163 6.125c.141.066.291.111.546.208-.445-1.065-.824-2.026-1.243-2.969a35.713 35.713 0 0 0-6.4-10.253c-.855-.908-.839-1.3-.036-2.4a58.918 58.918 0 0 0 7.23-13.475c.327-.835.6-1.692.91-2.533a1.071 1.071 0 0 1 1.552-.778c.384.11.753.269 1.128.409 1.552.577 3.1 1.159 4.657 1.729a6.415 6.415 0 0 0 .739.174 2.7 2.7 0 0 0-.084-.368c-.138-.332-.273-.665-.429-.987a78.117 78.117 0 0 0-5.167-9.022 1.2 1.2 0 0 1-.181-.687c.072-1.229.217-2.453.266-3.682a35.44 35.44 0 0 0-.44-9.008c-.191-.835-.368-1.669-.556-2.552zm-13.071 1.456c.51-.04 1.367-.087 2.218-.179a21.03 21.03 0 0 0 9.556-3.6.64.64 0 0 0 .276-.913 33.8 33.8 0 0 0-8.916-13.112c-.882-.791-1.852-1.485-2.8-2.2a1.243 1.243 0 0 0-1.435-.052 17.731 17.731 0 0 0-3.836 2.879 31.723 31.723 0 0 0-7.927 12.194c-.264.695-.265.705.345 1.142a21.14 21.14 0 0 0 12.519 3.841z",
    className: "cls-2Pesca",
    transform: "translate(-1401.461 -2074.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    d: "M1489.833 2123.832a2.512 2.512 0 1 1-.006 5.022 2.439 2.439 0 0 1-2.472-2.462 2.492 2.492 0 0 1 2.478-2.56z",
    className: "cls-2Pesca",
    transform: "translate(-1467.636 -2112.403)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPescatarianIcon);
export default __webpack_public_path__ + "static/media/pescatarian-icon.4c9ed15d.svg";
export { ForwardRef as ReactComponent };